"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Videos = void 0;
class Videos {
    static init() {
        const videos = document.querySelectorAll('section.variant-content video');
        videos.forEach((video) => {
            video.muted = true;
            const playPromise = video.play();
            if (playPromise !== undefined) {
                playPromise.then(() => {
                    const observer = new IntersectionObserver((entries) => {
                        entries.forEach((entry) => {
                            if (entry.intersectionRatio !== 1 && !video.paused) {
                                video.pause();
                            }
                            else if (video.paused) {
                                video.play();
                            }
                        });
                    }, 
                    /**
                     * threshold 1 means the video has to be fully visible before it will play,
                     * something like 0.1 would only need a sliver of it visible to start playing.
                     */
                    {
                        rootMargin: '0px',
                        threshold: 0.8,
                    });
                    observer.observe(video);
                });
            }
        });
    }
}
exports.Videos = Videos;
